export const CHALLAN_INFO_TITLE = 'Challans are easy to miss'
export const CHALLAN_INFO_SUBTITLE = 'They can be issued from anywhere.'
